<div class="grid m-4">
  <div class="col-12">
    <p>Dear User,</p>
    <p class="mb-4">Thank you for successfully registering with our application! We're thrilled to have you on board.
      To get started, please follow these simple steps:</p>
    <p>1. Download the App:</p>
    <p class="ml-4">For iOS users: Open the App Store on your iPhone or iPad and search for "PaperTrl".
      Once you find it, tap on the "Download" button and wait for the installation to complete.</p>
    <p>2. Log In:</p>
    <p class="ml-4">Launch the OurApp on your device.
      Enter your registered email address and password in the provided fields.
      Tap on the "Log In" button.</p>
  </div>
  <div class="col-12 mt-4 text-center">
    <a href="https://app.papertrl.com/mobile-download">
      <img alt="appstore" src="../../assets/images/appstore-download.png">
    </a>
  </div>
  <div class="col-12 text-center">
    <a href="https://app.papertrl.com/mobile-download">
      <img alt="playstore" src="../../assets/images/playstore-download.png">
    </a>
  </div>
</div>
